import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import {useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {LifeBuoy} from 'lucide-react';
import {useAuth} from '@/context/AuthContext';
import {api} from '@/lib/api';

export default function SupportLink({onClick}) {
  useUiLanguage();
  const {user, studio} = useAuth();
  const location = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    let active = true;
    setCount(0);
    const refresh = () => {
      if (document.hidden) return;
      api.get('/support/notifications').then(rows => {if(active) setCount(rows.length);}).catch(() => {});
    };
    refresh(); const timer = setInterval(refresh, 30000);
    window.addEventListener('tps:support-read', refresh);
    return () => {active=false; clearInterval(timer); window.removeEventListener('tps:support-read', refresh);};
  }, [user?.id, studio?.id]);
  return <Link to={user?.role === 'platform_admin' ? '/admin/support' : '/support'} state={{from: location.pathname}} onClick={onClick}
    className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-muted-foreground hover:bg-accent hover:text-foreground" data-testid="support-link">
    <LifeBuoy className="h-4 w-4 shrink-0"/><span>{user?.role === 'platform_admin' ? tr("Assistenza studi") : tr("Segnala un problema")}</span>
    {count > 0 && <span aria-label={tr("{{0}} aggiornamenti assistenza", {"0": count})} className="rounded-full bg-primary px-2 text-xs text-primary-foreground">{count}</span>}
  </Link>;
}
